// extracted by mini-css-extract-plugin
module.exports = {"bleed--true":"BUIProvider-module__bleed--true___nVmJp","bleed--0":"BUIProvider-module__bleed--0___IPy-n"};